export const ActionTypes = {
    APP_ID: "APP_ID",
    OKTAAPPID: "OKTA_ID",
    EMAILLOGO: "EMAIL_LOGO",
    HAM_ICON:"HAM_ICON"
}